import styled from 'styled-components';

export const StyledCircle = styled.div<{ isClickable: boolean }>`
    border-radius: 100%;
    cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
`;
